import { create } from 'axios';
import store from '@/store';
import router from '@/router';

const statusMap = {
    401: onUnauthenticated,
    422: onValidationFailed,
    404: onNotFound,
};

const instance = create({
    baseURL:
        process.env.VUE_APP_BASE_URL +
        process.env.VUE_APP_BASE_PATH,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

instance.interceptors.request.use(request => {
    const token = store.state.auth.token;

    if (token) {
        request.headers.common['Authorization'] = `Bearer ${token}`;
    }

    return request;
});

instance.interceptors.response.use(
    ({ data }) => data,
    error => Promise.reject(resolveStatus(error)),
);

function resolveStatus(error) {
    const { status } = error.response;

    if (!(status in statusMap)) {
        return error;
    }

    return statusMap[status](error);
}

function onNotFound(error) {
    router.push({ name: '404' });

    return error;
}
function onValidationFailed({ response }) {
    return response.data.errors;
}

function onUnauthenticated(error) {
    store.dispatch('auth/removeToken');

    router.push({ name: 'login' });

    return error;
}

export default instance;
